<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
      class="tw-stroke-[#0F172A] dark:tw-stroke-slate-50"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 2V14"
      class="tw-stroke-[#0F172A] dark:tw-stroke-slate-50"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.667 10L8.66699 8L10.667 6"
      class="tw-stroke-[#0F172A] dark:tw-stroke-slate-50"
      stroke-linecap="round"
      stroke-linejoin="round"
      :class="[
        props.isOpen ? 'tw-origin-center tw-rotate-180 tw-translate-x-1' : '',
      ]"
    />
  </svg>
</template>

<script setup>
const props = defineProps(["isOpen"]);
</script>
